var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"detail"},[(_vm.isEdit)?_c('article-edit',{attrs:{"close":_vm.handleClose,"form":_vm.itemForm,"id":_vm.reviseId}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }